var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgCareers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1233.022,
    height: 1720.685,
    viewBox: "0 0 1233.022 1720.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_52006",
    "data-name": "Raggruppa 52006",
    transform: "translate(-737.213 -947.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64857",
    "data-name": "Tracciato 64857",
    d: "M1935.5,966.5s-56.006,114.169,30,294c88,184-1228,1108-1228,1108",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64858",
    "data-name": "Tracciato 64858",
    d: "M1865.618,965.382s-33.141,107.921,66.411,305.118c94.084,186.365-1122.058,1115.588-1122.058,1115.588",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64859",
    "data-name": "Tracciato 64859",
    d: "M1795.735,964.265S1785.222,1066,1898.559,1280.5c99.8,188.873-1016.118,1123.176-1016.118,1123.176",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64860",
    "data-name": "Tracciato 64860",
    d: "M1725.853,963.147s11.9,95.622,139.235,327.353c105.23,191.5-910.176,1130.765-910.176,1130.765",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64861",
    "data-name": "Tracciato 64861",
    d: "M1655.971,962.029s34.115,89.6,175.647,338.471c110.454,194.228-804.236,1138.353-804.236,1138.353",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64862",
    "data-name": "Tracciato 64862",
    d: "M1586.088,960.912s56.156,83.659,212.059,349.588c115.516,197.04-698.294,1145.941-698.294,1145.941",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64863",
    "data-name": "Tracciato 64863",
    d: "M1516.206,959.794s78.033,77.814,248.47,360.706c120.451,199.924-592.352,1153.529-592.352,1153.529",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64864",
    "data-name": "Tracciato 64864",
    d: "M1446.324,958.676s99.763,72.061,284.882,371.824c125.283,202.87-486.412,1161.118-486.412,1161.118",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64865",
    "data-name": "Tracciato 64865",
    d: "M1376.441,957.559s121.357,66.4,321.294,382.941c130.033,205.871-380.47,1168.706-380.47,1168.706",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64866",
    "data-name": "Tracciato 64866",
    d: "M1306.559,956.441s142.823,60.819,357.706,394.059c134.717,208.92-274.53,1176.294-274.53,1176.294",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64867",
    "data-name": "Tracciato 64867",
    d: "M1236.676,955.324s164.175,55.326,394.118,405.176c139.346,212.01-168.588,1183.882-168.588,1183.882",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64868",
    "data-name": "Tracciato 64868",
    d: "M1166.794,954.206s185.418,49.916,430.53,416.294c143.93,215.138-62.648,1191.471-62.648,1191.471",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64869",
    "data-name": "Tracciato 64869",
    d: "M1096.912,953.088s206.56,44.585,466.941,427.412c148.477,218.3,43.294,1199.059,43.294,1199.059",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64870",
    "data-name": "Tracciato 64870",
    d: "M1027.029,951.971S1254.64,991.3,1530.382,1390.5c152.993,221.492,149.236,1206.647,149.236,1206.647",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64871",
    "data-name": "Tracciato 64871",
    d: "M957.147,950.853S1205.721,985,1496.912,1400.5c157.481,224.711,255.176,1214.235,255.176,1214.235",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64872",
    "data-name": "Tracciato 64872",
    d: "M887.265,949.735s269.456,29.032,576.176,460.765c161.949,227.956,361.118,1221.824,361.118,1221.824",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64873",
    "data-name": "Tracciato 64873",
    d: "M817.382,948.618s289.412,24.6,612.589,471.882c165.956,231.539,467.058,1229.412,467.058,1229.412",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64874",
    "data-name": "Tracciato 64874",
    d: "M747.5,947.5s311,19,649,483c170.828,234.51,573,1237,573,1237",
    fill: "none",
    stroke: "#be3144",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCareers);
export default __webpack_public_path__ + "static/media/bg-careers.85de701c50607ada0c5a3a863dd977a8.svg";
export { ForwardRef as ReactComponent };